import React, { useEffect, useState } from 'react';

const Testimonials = () => {
    const [activeTestimonial, setActiveTestimonial] = useState(0);

    // Auto-rotate testimonials
    useEffect(() => {
        const interval = setInterval(() => {
            setActiveTestimonial((prev) => (prev + 1) % testimonials.length);
        }, 6000);

        return () => clearInterval(interval);
    }, []);

    const testimonials = [
        {
            quote: "Desde que implementamos Grovi, nuestras reservas online han aumentado un 35%. El sistema es intuitivo tanto para nosotros como para los clientes.",
            author: "Martina Rodríguez",
            position: "Directora de Spa Wellness Center",
            image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=256&q=80",
            business: "Spa Wellness Center",
            color: "primary"
        },
        {
            quote: "La posibilidad de que los clientes reserven 24/7 ha transformado nuestro negocio. Ya no perdemos clientes potenciales fuera del horario de atención.",
            author: "Carlos Méndez",
            position: "Propietario de Barbería Premium",
            image: "https://images.unsplash.com/photo-1568602471122-7832951cc4c5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=256&q=80",
            business: "Barbería Premium",
            color: "secondary"
        },
        {
            quote: "Los recordatorios automáticos han reducido las cancelaciones de última hora en más de un 60%. Nuestra productividad ha mejorado notablemente.",
            author: "Laura Fernández",
            position: "Gerente de Centro de Yoga",
            image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=256&q=80",
            business: "Serene Yoga Studio",
            color: "primary"
        }
    ];

    return (
        <section className="py-24 bg-white relative overflow-hidden" id="testimonios">
            {/* Background shapes */}
            <div className="absolute top-0 right-0 w-1/3 h-full bg-gray-50 transform skew-x-12"></div>
            <div className="absolute left-20 top-20 w-16 h-16 bg-primary rounded-full opacity-10"></div>
            <div className="absolute right-40 bottom-20 w-32 h-32 bg-secondary rounded-full opacity-10"></div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="text-center max-w-3xl mx-auto mb-16">
                    <h2 className="text-4xl font-bold mb-6 text-secondary">
                        Lo Que Dicen Nuestros Clientes
                    </h2>
                    <p className="text-xl text-gray-600">
                        Negocios de todos los sectores confían en Grovi para gestionar sus servicios
                    </p>
                </div>

                {/* Testimonials carousel */}
                <div className="relative">
                    <div className="relative overflow-hidden">
                        <div
                            className="transition-transform duration-1000 ease-in-out flex"
                            style={{ transform: `translateX(-${activeTestimonial * 100}%)` }}
                        >
                            {testimonials.map((testimonial, index) => (
                                <div
                                    key={index}
                                    className="min-w-full px-4"
                                >
                                    <div className="bg-white rounded-3xl shadow-xl overflow-hidden transform transition-all duration-500 hover:shadow-2xl">
                                        <div className="grid md:grid-cols-2">
                                            {/* Left column with quote */}
                                            <div className={`p-12 bg-${testimonial.color}/10 flex flex-col justify-center relative`}>
                                                {/* Decorative quote mark */}
                                                <div className={`absolute top-6 left-6 text-${testimonial.color} opacity-20 transform scale-150`}>
                                                    <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M10.737 21.948c1.369 0 2.635-0.259 3.969-0.893l-1.844-3.995c-0.469 0.216-1.151 0.364-1.893 0.364-2.089 0-3.487-1.584-3.487-4.755v-0.364h5.443v-5.657h-9.412v5.443c0 5.552 2.016 9.857 7.224 9.857zM25.769 21.948c1.368 0 2.651-0.259 3.968-0.893l-1.843-3.995c-0.469 0.216-1.152 0.364-1.895 0.364-2.088 0-3.484-1.584-3.484-4.755v-0.364h5.441v-5.657h-9.413v5.443c0 5.552 2.016 9.857 7.225 9.857z"></path>
                                                    </svg>
                                                </div>

                                                <blockquote className="text-xl md:text-2xl font-medium text-gray-800 relative z-10">
                                                    "{testimonial.quote}"
                                                </blockquote>

                                                <div className="mt-8 flex items-center">
                                                    <div className={`w-12 h-12 rounded-full border-4 border-${testimonial.color} overflow-hidden flex-shrink-0`}>
                                                        <img
                                                            src={testimonial.image}
                                                            alt={testimonial.author}
                                                            className="w-full h-full object-cover"
                                                        />
                                                    </div>
                                                    <div className="ml-4">
                                                        <p className="font-bold text-gray-800">{testimonial.author}</p>
                                                        <p className="text-gray-600 text-sm">{testimonial.position}</p>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Right column with business showcase */}
                                            <div className="bg-gradient-to-br from-gray-800 to-gray-900 p-12 flex flex-col justify-center relative overflow-hidden">
                                                {/* Decorative shapes */}
                                                <div className={`absolute -bottom-10 -right-10 w-40 h-40 rounded-full bg-${testimonial.color} opacity-20`}></div>
                                                <div className={`absolute top-10 left-10 w-20 h-20 rounded-full bg-${testimonial.color} opacity-10`}></div>

                                                <div className="relative z-10 text-center">
                                                    <div className={`w-20 h-20 bg-${testimonial.color} rounded-xl mx-auto mb-6 flex items-center justify-center shadow-lg animate-float`}>
                                                        <span className="text-white text-3xl font-bold">{testimonial.business.charAt(0)}</span>
                                                    </div>

                                                    <h3 className="text-white text-2xl font-bold mb-4">{testimonial.business}</h3>

                                                    <div className="space-y-4 mt-8">
                                                        <div className="flex items-center justify-center text-white/80">
                                                            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7"></path>
                                                            </svg>
                                                            <span>Reservas online 24/7</span>
                                                        </div>
                                                        <div className="flex items-center justify-center text-white/80">
                                                            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7"></path>
                                                            </svg>
                                                            <span>Recordatorios automáticos</span>
                                                        </div>
                                                        <div className="flex items-center justify-center text-white/80">
                                                            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7"></path>
                                                            </svg>
                                                            <span>Sitio web personalizado</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Navigation dots */}
                    <div className="flex justify-center mt-8 space-x-3">
                        {testimonials.map((_, index) => (
                            <button
                                key={index}
                                onClick={() => setActiveTestimonial(index)}
                                className={`w-3 h-3 rounded-full transition-all duration-300 
                                    ${activeTestimonial === index
                                        ? 'bg-primary w-8'
                                        : 'bg-gray-300 hover:bg-gray-400'}`}
                                aria-label={`Ver testimonio ${index + 1}`}
                            ></button>
                        ))}
                    </div>
                </div>

                {/* Final CTA */}
                <div className="text-center mt-20">
                    <a href="https://wa.me/59892748021?text=Hola!%20Me%20interesa%20conocer%20más%20sobre%20Grovi%20para%20mi%20negocio" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-8 py-4 bg-primary text-white font-semibold rounded-lg shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-105">
                        Únete a nuestros clientes satisfechos
                        <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                        </svg>
                    </a>
                </div>
            </div>

            {/* Animations */}
            <style jsx="true">{`
                @keyframes float {
                    0% { transform: translateY(0px); }
                    50% { transform: translateY(-10px); }
                    100% { transform: translateY(0px); }
                }
                
                .animate-float {
                    animation: float 6s ease-in-out infinite;
                }
            `}</style>
        </section>
    );
};

export default Testimonials; 